import lottieWeb from "lottie-web";

export const lottie = () => {
  const els = document.querySelectorAll(".js-swipe-animation-inview");

  els.forEach((el) => {
    const animation = lottieWeb.loadAnimation({
      container: el, // アニメーションを格納するDOM要素
      renderer: "svg",
      loop: false,
      autoplay: false,
      path: `${themeData.themeUrl}/assets/lottie/swipe.json`, // JSONファイルのパス
      setSpeed: 1,
    });

    // IntersectionObserverを作成
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              animation.play();
              // 一度再生したら監視を解除（必要に応じてコメントアウト可能）
              setTimeout(() => {
                el.classList.add("is-animated");
              }, 1500);
              observer.unobserve(entry.target);
            }, 600);
          }
        });
      },
      {
        rootMargin: "-15% 0px",
      }
    );

    observer.observe(el);
  });
};
